import React, { useState } from "react";
import * as XLSX from "xlsx";
import { db } from "../firebaseConfig";
import { collection, setDoc, doc } from "firebase/firestore";
import {
  Box,
  Button,
  Typography,
  CircularProgress,
  Snackbar,
} from "@mui/material";

const ExcelUploader = ({ collectionName }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, message: "" });

  const handleFileUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    setIsLoading(true);

    try {
      const data = await file.arrayBuffer();
      const workbook = XLSX.read(data, { type: "array" });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];
      const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 }); // Encabezado en la fila 1

      const [headers, ...rows] = jsonData;

      const parsedData = rows.map((row) => {
        // Función para manejar campos vacíos
        const getValue = (key) => row[headers.indexOf(key)] || ""; // Si el valor está vacío, retorna una cadena vacía

        const formatos = [];
        for (let i = 0; i < 3; i++) {
          const formato = getValue(`f${i + 1}`);
          const cantidad = getValue(`c${i + 1}`);
          const precio = getValue(`p${i + 1}`);
          if (formato || cantidad || precio) {
            formatos.push({
              formato: formato || "", // Valor predeterminado
              cantidad: cantidad || "", // Valor predeterminado
              precio: precio || 0, // Valor predeterminado
            });
          }
        }

        return {
          id: getValue("PRODUCTO") || `producto_${Date.now()}`, // ID predeterminado si está vacío
          data: {
            ordenExcel: getValue("ORDEN EXCEL"),
            familia: getValue("FAMILIA"),
            subfam: getValue("SUBFAM."),
            producto: getValue("PRODUCTO"),
            formatos,
            imagenUrl: getValue("imagenUrl"),
            translations: {
              es: { name: getValue("PRODUCTO") },
              en: { name: getValue("en") },
              cat: { name: getValue("cat") },
              fr: { name: getValue("fr") },
            },
          },
        };
      });

      // Subir datos a Firestore con ID personalizado
      const collectionRef = collection(db, collectionName);
      const uploadPromises = parsedData.map(({ id, data }) =>
        setDoc(doc(collectionRef, id), data)
      );
      await Promise.all(uploadPromises);

      setSnackbar({ open: true, message: "Datos cargados exitosamente." });
    } catch (error) {
      console.error("Error al cargar los datos:", error);
      setSnackbar({ open: true, message: "Error al cargar los datos." });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Box sx={{ padding: 2, textAlign: "center" }}>
      <Typography variant="h6" sx={{ marginBottom: 2 }}>
        Importar Excel a Firebase
      </Typography>
      <Button
        variant="contained"
        component="label"
        sx={{ marginBottom: 2 }}
        disabled={isLoading}
      >
        Seleccionar Archivo
        <input
          type="file"
          accept=".xlsx, .xls"
          hidden
          onChange={handleFileUpload}
        />
      </Button>
      {isLoading && <CircularProgress />}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={() => setSnackbar({ open: false, message: "" })}
        message={snackbar.message}
      />
    </Box>
  );
};

export default ExcelUploader;
